import { message } from 'antd';
import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { skeletIcon } from '../../assets';
import Ava from '../../components/Common/Ava/Ava';

import ShortProfile from '../../components/Common/ShortProfile/ShortProfile';
import Modal from '../../components/Modal/Modal';
import Title from '../../components/Title/Title';
import UserProfile from '../../components/UserProfile/UserProfile';

import { TRootState } from '../../store/store';
import { transport } from '../../utils/constants';
import { filterNonEmptyMatrixTree, getColor, getLoginOrId, getToken, haptic, Haptick, PositionNode, setAvas, ViewState } from '../../utils/helper';
import './Areas.scss';
import { placesBinar } from './areas.types';
import { Reserv } from './Components/Reserv';
import { SettingBinary } from './Components/SettingBinary';
import { TeamBinarItem } from './Components/TeamBinarItem';
import { TreeNodes } from './Components/TreeNodes';
import { getAmountForBinar, getBranch, getInfoForBinar, getInfoForBinarS, getPositions, getTitleForBinar } from './helper';
import NotReferral from './Components/NotReferral/NotReferral';
import { Account_Info, Binary_Position, Matrix_View, PositionView_Team, TreeAccount_Entity } from '../../generated/mlmbox/types/account';
import { TeamResponse } from '../../generated/mlmbox/client/network/network';
import { MatrixClient } from '../../generated/mlmbox/client/matrix/matrix.client';
import { NetworkClient } from '../../generated/mlmbox/client/network/network.client';
import { Sort_Direction } from '../../generated/mlmbox/types/sort';
import { BinaryClient } from '../../generated/mlmbox/client/binary/binary.client';
import { ProductClient } from '../../generated/mlmbox/client/product/product.client';
import { Relationship_Kind } from '../../generated/mlmbox/types/relationship';
import Button from '../../components/Button/Button';

const Areas: FC = () => {
    const { t } = useTranslation();

    const accId = useSelector((state: TRootState) => state.user.value.info.account.id);
    const acc = useSelector((state: TRootState) => state.user.value);
    const schemes = useSelector((state: TRootState) => state.schemes.value);
    const treeAccounts = useSelector((state: TRootState) => state.user.value.treeAccounts);

    const [fetching, setFetching] = useState<boolean>(true);

    const [category, setCategory] = useState('Workers');
    const [group, setGroup] = useState(1);
    const [tree, setTree] = useState<PositionNode | undefined>();
    const [money, setMoney] = useState(1);
    const [moneyActive, setMoneyActive] = useState(true);

    const [prevPositionId, setPrevPositionId] = useState<number>();
    const [viewPositionId, setViewPositionId] = useState<number | null>(null);
    const [viewPositionIdMain, setViewPositionIdMain] = useState<number | null>(null);
    const [positionId, setPositionId] = useState<number | null>(null);

    const [userView, setUserView] = useState<Account_Info | null>();
    const [shortInfo, setShotInfo] = useState<TeamResponse | null>();
    const [info, setInfo] = useState<Account_Info | null>();
    const [userInfoOpen, setUserInfoOpen] = useState(false);
    const [userInfoOpenB, setUserInfoOpenB] = useState(false);

    const [matrixView, setMatrixView] = useState<Matrix_View>();
    const [positionIdList, setPositionIdList] = useState<TreeAccount_Entity[]>([]);
    const [notHave, setNotHave] = useState(false);

    const pag = useRef<HTMLDivElement>(null);
    const [tab, setTab] = useState(1);
    const [leftBranch, setLeftBranch] = useState<(Account_Info & Binary_Position) | null>(null);
    const [rightBranch, setRightBranch] = useState<(Account_Info & Binary_Position) | null>(null);
    const [mediumBranch, setMediumBranch] = useState<(Account_Info & Binary_Position) | null>(null);
    const [shortInfoB, setShortInfoB] = useState<TeamResponse | null>();
    const [infoB, setInfoB] = useState<Account_Info | null>();
    const [up, setUp] = useState(false);
    const [positionBinary, setPositionBinary] = useState<number | null>(null);
    const [positionBinaryList, setPositionBinaryList] = useState<number[]>([]);
    const [loadBinary, setLoadBinary] = useState(true);
    const [openSetting, setOpenSetting] = useState(false);
    const [fetchBinary, setFetchBinary] = useState(false);
    const [mainPosition, setMainPosition] = useState(false);
    const [_, setNoSend] = useState(false);

    const [binar, setBinar] = useState(false);
    const [valueBinar, setValueBinar] = useState(0);
    const [positions, setPositions] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const [value, setValue] = useState(0);
    const [isReady, setIsReady] = useState(false);
    const wallet = useSelector((state: TRootState) => state.wallet.value);

    const [del, setDel] = useState(0.1);

    const navigate = useNavigate();

    const matrixClient = new MatrixClient(transport);
    const networkClient = new NetworkClient(transport);
    const binaryClient = new BinaryClient(transport);
    const productClient = new ProductClient(transport);

    useEffect(() => {
        if (schemes?.treeGroups.length > 0 && !filterNonEmptyMatrixTree(treeAccounts).length) {
            setMainPosition(true);
            setNotHave(true);
            setFetching(false);
        }
        if (!filterNonEmptyMatrixTree(treeAccounts).length) {
            return;
        }
        if (fetching && accId && filterNonEmptyMatrixTree(treeAccounts).length) {
            setShotInfo(null);
            setInfo(null);

            let result = filterNonEmptyMatrixTree(treeAccounts)[money - 1]?.entities.find((el) => el.filled === false && el.viewAccess === true);
            if (!result) {
                result = filterNonEmptyMatrixTree(treeAccounts)[money - 1]?.entities[0];
            }

            const matrixRequest: PositionView_Team = {
                viewLevel: 2,
                query: {
                    viewPositionId: viewPositionId ? viewPositionId : positionId ? positionId : result.positionId,
                    oneofKind: 'viewPositionId',
                },
            };

            matrixClient.view(matrixRequest, { meta: { authorization: getToken() } }).then(async ({ status, response }) => {
                if (status.code === 'OK') {
                    if (!positionId) setPositionId(result?.positionId ?? null);
                    setMatrixView(response);
                    response.positions.forEach((el) => {
                        response.accounts.forEach((account) => {
                            if (el.positionId === response.viewPositionId) {
                                if (response.viewPositionId !== response.selfPositionId) {
                                    viewPositionId && setPrevPositionId(el.positionRefId);
                                } else {
                                    setPrevPositionId(0);
                                }

                                if (el.accountId === account.account?.id) setUserView(account);
                            }
                        });
                    });

                    const info = response.accounts;
                    if (info) await setAvas(info);

                    response.selfPositionId === response.viewPositionId && setViewPositionIdMain(response.viewPositionId);
                    !viewPositionId && setMainPosition(true);
                    setMoneyActive(true);
                    setNotHave(false);
                }
            });
        }
    }, [fetching, accId, viewPositionId]);

    useEffect(() => {
        if (userView && userView.account) {
            networkClient
                .teamInfo(
                    {
                        filterChannels: [],
                        filterTreeIdsBitMask: 0,
                        partnersSort: {
                            direction: Sort_Direction.BACKWARD,
                            limit: 10,
                        },
                        viewPartner: {
                            uniqueField: {
                                accountId: userView.account?.id,
                                oneofKind: 'accountId',
                            },
                        },
                    },
                    { meta: { authorization: getToken() } }
                )
                .then(async ({ status, response }) => {
                    if (status.code === 'OK') {
                        const info = response;
                        if (info) {
                            await setAvas(info.partners);
                            await setAvas(info.referrals);
                        }
                        setShotInfo(response);
                    }
                })
                .catch(() => {
                    setInfo(userView);
                })
                .finally(() => {
                    setFetching(false);
                });
        } else {
            setInfo(null);
            setShortInfoB(null);
        }
    }, [userView]);

    useEffect(() => {
        if (matrixView?.positions.length) {
            const view = new ViewState();

            schemes.treeGroups.forEach((el) => {
                view.addGroup({ title: el.title, id: el.id });
            });
            schemes.trees.forEach((el) => {
                view.addTree({
                    amountValue: String(el.amount?.value),
                    groupId: el.groupId,
                    title: el.title,
                    defaultPositionWidth: el.defaultPositionWidth,
                    id: el.id,
                    amountAssetId: Number(el.amount?.assetId),
                });

                view.addGroup({ id: el.id, title: el.title });
            });

            matrixView.positions.forEach((el) => {
                matrixView.accounts.forEach((account) => {
                    if (el.accountId === account.account?.id) {
                        if (account.account.id === 86781) console.log('86781 --->', matrixView);
                        view.addPosition({
                            positionId: el.positionId,
                            positionRefId: el.positionRefId,
                            positionRefLine: el.positionRefBranch,
                            positionWidth: el.positionWidth,
                            accountId: Number(el.accountId),
                            reinvestEnabled: el.reinvestEnabled,
                            treeAccountId: el.accountId,
                            ava: account.profile?.ava,
                            relationship: account.relationship,
                        });
                    }
                });

                //;
            });

            setTree(viewPositionId ? view.cacheView(money, Number(viewPositionId), 2) : view.cacheView(money, Number(positionId), 2));
        }
    }, [matrixView]);

    useEffect(() => {
        if (group === 1) setMoney(1);
        if (group === 2) setMoney(6);
        if (group === 3) setMoney(11);
    }, [group]);

    useEffect(() => {
        // if (!noSend) return;
        if (!filterNonEmptyMatrixTree(treeAccounts).length) {
            return;
        }
        const find = filterNonEmptyMatrixTree(treeAccounts).find((el) => el.treeId === money);

        if (!find || find?.bookingQuantity > 0) {
            setMainPosition(true);
            setNotHave(true);
            setFetching(false);
            return;
        }
        setNotHave(false);
        setMoneyActive(false);

        if (filterNonEmptyMatrixTree(treeAccounts).length && !viewPositionId) {
            filterNonEmptyMatrixTree(treeAccounts).forEach((el) => {
                if (el.treeId === money) {
                    const res = el.entities.filter((e) => e.viewAccess);
                    setFetching(true);

                    setPositionIdList(res);
                }
            });
        }
    }, [money, schemes, viewPositionId]);

    useEffect(() => {
        setLoadBinary(true);
        if (!mainPosition) return;
        if (fetchBinary) {
            setOpenSetting(false);
        }

        setMediumBranch(null);
        setLeftBranch(null);
        setRightBranch(null);
        setUp(false);

        const binaryRequest: PositionView_Team = {
            viewLevel: 1,
            query: positionBinary
                ? {
                      oneofKind: 'viewPositionId',
                      viewPositionId: positionBinary,
                  }
                : {
                      oneofKind: 'treeAccountId',
                      treeAccountId: {
                          treeId: tab === 1 ? 16 : 17,
                          accountId: acc.info.account.id,
                      },
                  },
        };

        if (positionBinary) {
            !up && mediumBranch?.positionId && setPositionBinaryList((prev) => [...prev, mediumBranch?.positionId]);
        } else {
            setPositionBinaryList([]);
        }

        binaryClient
            .view(binaryRequest, { meta: { authorization: getToken() } })
            .then(async ({ status, response }) => {
                if (status.code === 'OK') {
                    response.config?.bonusBinaryPercent && setDel(Number(response.config?.bonusBinaryPercent));
                    const info = response;

                    if (info) {
                        await setAvas(info.accounts);
                    }

                    response.positions.forEach((el) => {
                        if (el.positionId === response.viewPositionId) {
                            response.accounts.forEach((acc) => {
                                if (acc.account?.id === el.accountId) setMediumBranch({ ...acc, ...el });
                            });
                        }
                        if (el.positionRefBranch === 1 && el.positionId !== response.viewPositionId) {
                            response.accounts.forEach((acc) => {
                                if (acc.account?.id === el.accountId) setLeftBranch({ ...acc, ...el });
                            });
                        }
                        if (el.positionRefBranch === 2 && el.positionId !== response.viewPositionId) {
                            response.accounts.forEach((acc) => {
                                if (acc.account?.id === el.accountId) setRightBranch({ ...acc, ...el });
                            });
                        }
                        setFetchBinary(false);
                    });
                }
            })
            .catch(() => {})
            .finally(() => {
                setLoadBinary(false);
            });
    }, [positionBinary, tab, fetchBinary, mainPosition]);

    useEffect(() => {
        if (loadBinary) return;
        setPositionBinaryList([]);
        setPositionBinary(null);
    }, [tab]);

    function getAccount(id: number) {
        networkClient
            .teamInfo(
                {
                    filterChannels: [],
                    filterTreeIdsBitMask: 0,
                    partnersSort: {
                        direction: Sort_Direction.BACKWARD,
                        limit: 10,
                    },
                    viewPartner: {
                        uniqueField: {
                            accountId: id,
                            oneofKind: 'accountId',
                        },
                    },
                },
                { meta: { authorization: getToken() } }
            )
            .then(async ({ status, response }) => {
                if (status.code === 'OK') {
                    const info = response;
                    if (info) {
                        await setAvas(info.partners);
                        await setAvas(info.referrals);
                    }
                    setShortInfoB(response);
                }
            })
            .catch(() => {
                mediumBranch?.channels &&
                    setInfoB({
                        account: mediumBranch?.account,
                        channels: mediumBranch?.channels,

                        referralBranch: mediumBranch?.referralBranch,
                        referral: mediumBranch?.referral,
                        registrationAt: mediumBranch?.registrationAt,
                        profile: mediumBranch?.profile,
                        relationship: mediumBranch?.relationship,
                        statistics: mediumBranch?.statistics,
                        marketingStartedAt: mediumBranch.marketingStartedAt,
                        treeIdsBitMask: mediumBranch?.treeIdsBitMask,
                    });
            })
            .finally(() => {
                setUserInfoOpenB(true);
            });
    }

    function binarFetch(num: number, tab: number): void {
        const treeId = tab === 1 ? 16 : 17;
        const binarMatrix = treeAccounts.find((el) => el.treeId === treeId);
        if (!binarMatrix) return;
        const binars = binarMatrix?.bookingQuantity > 0 || binarMatrix?.entities.length > 0;

        isReady
            ? productClient
                  .verifiedPurchase(
                      {
                          entities: [
                              {
                                  quantity: num,
                                  treeId: treeId,
                              },
                          ],
                      },
                      {
                          meta: {
                              authorization: getToken(),
                          },
                      }
                  )
                  .then(() => {
                      setIsReady(false);
                      message.success('Площадка активирована');
                      window.location.reload();
                  })
                  .finally(() => {
                      setIsReady(false);
                  })
            : productClient
                  .previewPurchase(
                      {
                          entities: [
                              {
                                  quantity: num,
                                  treeId: treeId,
                              },
                          ],
                      },
                      { meta: { authorization: getToken() } }
                  )
                  .then(({ status, response }) => {
                      setPositions(getPositions(response.items));

                      if (status.code === 'OK') {
                          if (!binar && !binars) {
                              setQuantity(1);
                              tab === 1 ? setValueBinar(25) : setValueBinar(800);

                              setBinar(true);
                          } else if (Number(response.billAmounts[0].value) > Number(wallet.assets[0].assetBalance)) {
                              setValue(Number(response.billAmounts[0].value) - Number(wallet.assets[0].assetBalance));
                              window.Telegram.WebApp.HapticFeedback.notificationOccurred('error');
                              setIsOpen(true);
                          } else {
                              setValue(Number(response.billAmounts[0].value));
                              setIsReady(true);
                          }
                      }
                  });
    }

    return (
        <>
            {!acc.info.referral.id && acc.info.account.id !== 1 && acc.info.account.id !== 85475 ? (
                <NotReferral />
            ) : (
                <div
                    className="areas"
                    id="section">
                    <Title text={t('matrix.title')} />

                    <div className="area">
                        <div className="area__select">
                            <div className="area__select--category">
                                {schemes.treeGroups.map(
                                    (el) =>
                                        el.id !== 4 && (
                                            <div
                                                className={`area__select--category__item ${category === el.title ? 'active' : ''} ${
                                                    category === 'Workers' ? 'green' : category === 'Business' ? 'blue' : 'red'
                                                }`}
                                                key={el.id}
                                                onClick={() => {
                                                    if (!moneyActive && fetching) return;
                                                    setCategory(el.title);
                                                    setViewPositionId(null);
                                                    setPrevPositionId(0);
                                                    setUserView(null);
                                                    setNoSend(true);
                                                    setGroup(el.id);

                                                    setPositionId(null);
                                                    Haptick(haptic.light);
                                                }}>
                                                <h2>
                                                    {el.title === 'Workers'
                                                        ? t('matrix.groups.workers')
                                                        : el.title === 'Business'
                                                        ? t('matrix.groups.business')
                                                        : t('matrix.groups.invest')}
                                                </h2>
                                            </div>
                                        )
                                )}
                            </div>
                            <div className="area__select--money">
                                {schemes.trees.map(
                                    (el) =>
                                        el.groupId === group && (
                                            <div
                                                className={`area__select--money__item ${
                                                    el.groupId === 1 ? 'green' : el.groupId === 2 ? 'blue' : 'red'
                                                } ${el.id === money ? 'active' : ''}`}
                                                key={el.id}
                                                onClick={() => {
                                                    if (!moneyActive && fetching) return;
                                                    setPositionId(null);
                                                    setNoSend(true);
                                                    setUserView(null);
                                                    setViewPositionId(null);
                                                    setPrevPositionId(0);
                                                    setMoney(el.id);
                                                    Haptick(haptic.light);
                                                }}>
                                                {Number(el?.amount?.value) === 12800 && (
                                                    <p>
                                                        12.8K <span>$</span>
                                                    </p>
                                                )}

                                                {Number(el?.amount?.value) !== 12800 && (
                                                    <p>
                                                        {String(Number(el?.amount?.value)).length >= 5
                                                            ? String(Number(el?.amount?.value)).slice(
                                                                  0,
                                                                  String(Number(el?.amount?.value)).length - 3
                                                              ) + 'K'
                                                            : Number(el?.amount?.value).toFixed(0)}
                                                        <span>$</span>
                                                    </p>
                                                )}
                                            </div>
                                        )
                                )}
                            </div>
                        </div>

                        <div className="area__main">
                            {fetching ? (
                                <div className="load">
                                    <div className="spinner"></div>
                                </div>
                            ) : notHave ? (
                                <Reserv treeId={money} />
                            ) : (
                                <>
                                    <div className="circle-group">
                                        {tree && (
                                            <TreeNodes
                                                setViewPosotionId={setViewPositionId}
                                                setFetching={setFetching}
                                                node={tree}
                                            />
                                        )}
                                        <img
                                            className="skelet"
                                            src={skeletIcon}
                                            alt=""
                                        />
                                    </div>
                                </>
                            )}
                        </div>

                        {!notHave && (
                            <div className="partner">
                                <div className="inner">
                                    <div className="avatar">
                                        {(prevPositionId && shortInfo && !fetching) || (prevPositionId && info && !fetching) ? (
                                            <div
                                                className="icon"
                                                onClick={() => {
                                                    if (fetching) return;
                                                    setUserInfoOpen(true);
                                                }}>
                                                <svg
                                                    width="23"
                                                    height="22"
                                                    viewBox="0 0 23 22"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M6.2679 0.249985H16.7321C17.5449 0.249978 18.2006 0.249972 18.7315 0.293349C19.2781 0.338011 19.7582 0.43237 20.2025 0.658711C20.9081 1.01824 21.4817 1.59191 21.8413 2.29752C22.0676 2.74174 22.162 3.22188 22.2066 3.76852C22.25 4.29942 22.25 4.95503 22.25 5.76786V16.2321C22.25 17.0449 22.25 17.7005 22.2066 18.2315C22.162 18.7781 22.0676 19.2582 21.8413 19.7024C21.4817 20.4081 20.9081 20.9817 20.2025 21.3413C20.0468 21.4206 19.8858 21.4842 19.7174 21.5352C19.0069 21.7505 18.0935 21.7503 16.8363 21.75C16.7913 21.75 16.7459 21.75 16.7 21.75H6.3C6.25412 21.75 6.20868 21.75 6.16368 21.75C4.90651 21.7503 3.99309 21.7505 3.28256 21.5352C3.11424 21.4842 2.95325 21.4206 2.79754 21.3413C2.09193 20.9817 1.51825 20.4081 1.15873 19.7024C0.932385 19.2582 0.838026 18.7781 0.793364 18.2315C0.749987 17.7005 0.749993 17.0449 0.75 16.2321V5.76788C0.749993 4.95504 0.749987 4.29943 0.793364 3.76852C0.838026 3.22188 0.932385 2.74174 1.15873 2.29752C1.51825 1.59191 2.09193 1.01824 2.79754 0.658711C3.24175 0.43237 3.7219 0.338011 4.26853 0.293349C4.79944 0.249972 5.45506 0.249978 6.2679 0.249985ZM4.39068 1.78837C3.9368 1.82545 3.67604 1.89458 3.47852 1.99522C3.05516 2.21094 2.71095 2.55514 2.49524 2.97851C2.3946 3.17602 2.32547 3.43679 2.28838 3.89067C2.25058 4.3533 2.25 4.94753 2.25 5.79999V16.2C2.25 17.0524 2.25058 17.6467 2.28838 18.1093C2.32547 18.5632 2.3946 18.8239 2.49524 19.0215C2.57533 19.1787 2.67314 19.3249 2.78614 19.4578C2.7992 19.3221 2.81699 19.1954 2.84127 19.0733C3.21608 17.189 4.68904 15.7161 6.57332 15.3413C7.03323 15.2498 7.56665 15.2499 8.40471 15.25C8.43604 15.25 8.4678 15.25 8.5 15.25H14.5C14.5322 15.25 14.564 15.25 14.5953 15.25C15.4334 15.2499 15.9668 15.2498 16.4267 15.3413C18.311 15.7161 19.7839 17.189 20.1587 19.0733C20.183 19.1954 20.2008 19.3221 20.2139 19.4578C20.3269 19.3249 20.4247 19.1787 20.5048 19.0215C20.6054 18.8239 20.6745 18.5632 20.7116 18.1093C20.7494 17.6467 20.75 17.0524 20.75 16.2V5.79999C20.75 4.94753 20.7494 4.3533 20.7116 3.89067C20.6745 3.43679 20.6054 3.17602 20.5048 2.97851C20.289 2.55514 19.9448 2.21094 19.5215 1.99522C19.324 1.89458 19.0632 1.82545 18.6093 1.78837C18.1467 1.75057 17.5525 1.74999 16.7 1.74999H6.3C5.44755 1.74999 4.85331 1.75057 4.39068 1.78837ZM18.7467 20.1995C18.741 19.7866 18.7258 19.5582 18.6876 19.3659C18.4311 18.0767 17.4233 17.0689 16.134 16.8124C15.8384 16.7536 15.4653 16.75 14.5 16.75H8.5C7.53474 16.75 7.16164 16.7536 6.86596 16.8124C5.57671 17.0689 4.5689 18.0767 4.31245 19.3659C4.27421 19.5582 4.259 19.7866 4.25326 20.1995C4.70023 20.2462 5.3243 20.25 6.3 20.25H16.7C17.6757 20.25 18.2998 20.2462 18.7467 20.1995ZM11.5 5.24999C9.70507 5.24999 8.25 6.70506 8.25 8.49998C8.25 10.2949 9.70507 11.75 11.5 11.75C13.2949 11.75 14.75 10.2949 14.75 8.49998C14.75 6.70506 13.2949 5.24999 11.5 5.24999ZM6.75 8.49998C6.75 5.87663 8.87665 3.74999 11.5 3.74999C14.1234 3.74999 16.25 5.87663 16.25 8.49998C16.25 11.1233 14.1234 13.25 11.5 13.25C8.87665 13.25 6.75 11.1233 6.75 8.49998Z"
                                                        fill="#89B1FF"
                                                    />
                                                </svg>
                                            </div>
                                        ) : (
                                            <div className="not-back"></div>
                                        )}
                                        <div className="border-circle">
                                            <div className="circle">
                                                {info && !fetching && (
                                                    <Ava
                                                        width="84px"
                                                        height="84px"
                                                        borderColor={getColor(info.relationship)}
                                                        collectionId={info.profile?.ava?.collectionId}
                                                        entityId={info.profile?.ava?.entityId}
                                                    />
                                                )}
                                                {shortInfo && !fetching && (
                                                    <Ava
                                                        width="84px"
                                                        height="84px"
                                                        borderColor={getColor(shortInfo?.account?.relationship)}
                                                        collectionId={shortInfo?.account?.profile?.ava?.collectionId}
                                                        entityId={shortInfo?.account?.profile?.ava?.entityId}
                                                    />
                                                )}
                                                {fetching && (
                                                    <Ava
                                                        width="84px"
                                                        height="84px"
                                                        borderColor="#0462F9"
                                                        collectionId={0}
                                                        entityId={0}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        {prevPositionId && !fetching ? (
                                            <div
                                                className="icon"
                                                onClick={() => {
                                                    if (fetching) return;
                                                    setViewPositionId(prevPositionId);
                                                    setInfo(null);
                                                    setFetching(true);
                                                }}>
                                                <svg
                                                    width="23"
                                                    height="22"
                                                    viewBox="0 0 23 22"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M6.83383 0.25H16.1662C17.0624 0.249992 17.7852 0.249985 18.3706 0.297811C18.9733 0.347054 19.5027 0.451092 19.9925 0.700647C20.7704 1.09705 21.403 1.72956 21.7994 2.50754C22.0489 2.99732 22.1529 3.52671 22.2022 4.12941C22.25 4.71476 22.25 5.43761 22.25 6.33381V15.6662C22.25 16.5624 22.25 17.2852 22.2022 17.8706C22.1529 18.4733 22.0489 19.0027 21.7994 19.4925C21.403 20.2704 20.7704 20.903 19.9925 21.2994C19.5027 21.5489 18.9733 21.6529 18.3706 21.7022C17.7852 21.75 17.0624 21.75 16.1662 21.75H6.83381C5.93761 21.75 5.21476 21.75 4.62941 21.7022C4.02671 21.6529 3.49732 21.5489 3.00754 21.2994C2.22956 20.903 1.59705 20.2704 1.20065 19.4925C0.951092 19.0027 0.847054 18.4733 0.797811 17.8706C0.749985 17.2852 0.749992 16.5624 0.75 15.6662V6.33383C0.749992 5.43763 0.749985 4.71477 0.797811 4.12941C0.847054 3.52671 0.951092 2.99732 1.20065 2.50754C1.59705 1.72956 2.22956 1.09705 3.00754 0.700647C3.49732 0.451092 4.02671 0.347054 4.62941 0.297811C5.21477 0.249985 5.93763 0.249992 6.83383 0.25ZM4.76408 1.94616C4.26366 1.98705 3.97615 2.06327 3.75837 2.17423C3.29158 2.41207 2.91207 2.79158 2.67423 3.25837C2.56327 3.47615 2.48705 3.76366 2.44616 4.26408C2.40449 4.77416 2.40385 5.42935 2.40385 6.36923V15.6308C2.40385 16.5707 2.40449 17.2258 2.44616 17.7359C2.48705 18.2363 2.56327 18.5239 2.67423 18.7416C2.91207 19.2084 3.29158 19.5879 3.75837 19.8258C3.97615 19.9367 4.26366 20.0129 4.76408 20.0538C5.27416 20.0955 5.92935 20.0962 6.86923 20.0962H16.1308C17.0707 20.0962 17.7258 20.0955 18.2359 20.0538C18.7363 20.0129 19.0239 19.9367 19.2416 19.8258C19.7084 19.5879 20.0879 19.2084 20.3258 18.7416C20.4367 18.5239 20.5129 18.2363 20.5538 17.7359C20.5955 17.2258 20.5962 16.5707 20.5962 15.6308V6.36923C20.5962 5.42935 20.5955 4.77416 20.5538 4.26408C20.5129 3.76366 20.4367 3.47615 20.3258 3.25837C20.0879 2.79158 19.7084 2.41207 19.2416 2.17423C19.0239 2.06327 18.7363 1.98705 18.2359 1.94616C17.7258 1.90449 17.0707 1.90385 16.1308 1.90385H6.86923C5.92935 1.90385 5.27416 1.90449 4.76408 1.94616ZM11.5 5.76282C11.9567 5.76282 12.3269 6.13305 12.3269 6.58974V13.4139L15.3255 10.4153C15.6485 10.0923 16.172 10.0923 16.495 10.4153C16.8179 10.7382 16.8179 11.2618 16.495 11.5847L12.0847 15.995C11.7618 16.3179 11.2382 16.3179 10.9153 15.995L6.50502 11.5847C6.18209 11.2618 6.18209 10.7382 6.50502 10.4153C6.82795 10.0923 7.35153 10.0923 7.67447 10.4153L10.6731 13.4139V6.58974C10.6731 6.13305 11.0433 5.76282 11.5 5.76282Z"
                                                        fill="#89B1FF"
                                                    />
                                                </svg>
                                            </div>
                                        ) : (
                                            <div className="not-back"></div>
                                        )}
                                    </div>
                                    {info && !fetching && <h3>{getLoginOrId(info)}</h3>}
                                    {shortInfo && !fetching && <h3>{shortInfo.account && getLoginOrId(shortInfo.account)}</h3>}
                                    {fetching && <h3></h3>}
                                </div>
                            </div>
                        )}
                        {!notHave && (
                            <div
                                className="area__pagination"
                                ref={pag}>
                                {!viewPositionId &&
                                    positionIdList.map((el, i) => (
                                        <p
                                            onClick={() => {
                                                setViewPositionId(null);

                                                setPositionId(el.positionId);
                                                setFetching(true);
                                                Haptick(haptic.light);
                                            }}
                                            className={`position-${el.positionId} ${positionId === el.positionId ? 'active' : ''} `}
                                            key={'pag' + i}>
                                            {el.treeAccountEntityId}
                                        </p>
                                    ))}
                                {viewPositionId &&
                                    positionIdList.map((el, i) =>
                                        el.viewAccess ? (
                                            <p
                                                onClick={() => {
                                                    setViewPositionId(el.positionId);
                                                    setFetching(true);
                                                    Haptick(haptic.light);
                                                }}
                                                className={`position-${el.positionId} ${viewPositionIdMain === el.positionId ? 'active' : ''} `}
                                                key={'pag3' + i}>
                                                {el.treeAccountEntityId}
                                            </p>
                                        ) : (
                                            <p
                                                style={{ opacity: 0.5 }}
                                                key={'pag2' + i}>
                                                {el.treeAccountEntityId}
                                            </p>
                                        )
                                    )}
                            </div>
                        )}
                    </div>

                    <>
                        <div className="line"></div>
                        <Title text={t('bin')} />
                        <div className="binars">
                            <div className="binar-tabs">
                                <button
                                    onClick={() => {
                                        if (loadBinary) return;
                                        setTab(1);
                                        Haptick(haptic.light);
                                    }}
                                    className={`green tab ${tab === 1 ? 'active' : ''}`}>
                                    {t('bin.tab1')}
                                </button>
                                <button
                                    onClick={() => {
                                        if (loadBinary) return;
                                        setTab(2);
                                        Haptick(haptic.light);
                                    }}
                                    className={`blue tab ${tab === 2 ? 'active' : ''}`}>
                                    {t('bin.tab2')}
                                </button>
                            </div>
                            <p>{treeAccounts.length > 0 && getTitleForBinar(tab === 1 ? treeAccounts[15] : treeAccounts[16])}</p>
                            {(tab === 1 ? getInfoForBinar(treeAccounts[15]) : getInfoForBinar(treeAccounts[16])) === placesBinar.ONE && (
                                <Button
                                    title={t('bin.btn_one', {
                                        amount: getAmountForBinar(tab),
                                    })}
                                    onClick={() => {
                                        setQuantity(1);
                                        binarFetch(1, tab);
                                    }}
                                />
                            )}
                            {(tab === 1 ? getInfoForBinar(treeAccounts[15]) : getInfoForBinar(treeAccounts[16])) === placesBinar.THREE && (
                                <>
                                    <Button
                                        title={t('bin.btn_three', {
                                            amount: getAmountForBinar(tab) * 2,
                                        })}
                                        onClick={() => {
                                            setQuantity(2);
                                            binarFetch(2, tab);
                                        }}
                                    />
                                    <Button
                                        title={t('bin.btn_seven', {
                                            amount: getAmountForBinar(tab) * 6,
                                        })}
                                        onClick={() => {
                                            setQuantity(6);
                                            binarFetch(6, tab);
                                        }}
                                    />
                                </>
                            )}
                            {(tab === 1 ? getInfoForBinar(treeAccounts[15]) : getInfoForBinar(treeAccounts[16])) === placesBinar.SEVEN && (
                                <>
                                    <Button
                                        title={t('bin.btn_seven', {
                                            amount: getAmountForBinar(tab) * 4,
                                        })}
                                        onClick={() => {
                                            setQuantity(4);
                                            binarFetch(4, tab);
                                        }}
                                    />
                                </>
                            )}
                            {(tab === 1 ? getInfoForBinar(treeAccounts[15]) : getInfoForBinar(treeAccounts[16])) === placesBinar.ACTIVE &&
                                (loadBinary ? (
                                    <div className="load">
                                        <div className="spinner"></div>
                                    </div>
                                ) : (
                                    <div className="binars__info">
                                        <div className="btns">
                                            <svg
                                                onClick={() => {
                                                    setPositionBinaryList([]);
                                                    setPositionBinary(null);
                                                }}
                                                style={{ width: loadBinary || positionBinaryList.length === 0 ? '0px' : 'unset' }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none">
                                                <rect
                                                    className="rect"
                                                    width="20"
                                                    height="20"
                                                    rx="4"
                                                    fill="#333650"
                                                />
                                                <path
                                                    d="M7.9 16V11.264C7.9 10.9056 7.9 10.7263 7.9763 10.5894C8.04341 10.469 8.15049 10.3711 8.28221 10.3098C8.43195 10.24 8.62797 10.24 9.02 10.24H10.98C11.372 10.24 11.5681 10.24 11.7178 10.3098C11.8495 10.3711 11.9566 10.469 12.0237 10.5894C12.1 10.7263 12.1 10.9056 12.1 11.264V16M3 8.64L9.328 4.3008C9.56898 4.13556 9.68947 4.05293 9.8218 4.02108C9.93861 3.99297 10.0614 3.99297 10.1782 4.02108C10.3105 4.05293 10.431 4.13556 10.672 4.3008L17 8.64M4.4 7.68V13.952C4.4 14.6689 4.4 15.0273 4.55259 15.3011C4.68682 15.542 4.90099 15.7378 5.16442 15.8605C5.46389 16 5.85593 16 6.64 16H13.36C14.1441 16 14.5361 16 14.8356 15.8605C15.099 15.7378 15.3132 15.542 15.4474 15.3011C15.6 15.0273 15.6 14.6689 15.6 13.952V7.68L11.344 4.7616C10.862 4.43111 10.6211 4.26587 10.3564 4.20217C10.1228 4.14594 9.87722 4.14594 9.64361 4.20217C9.37894 4.26587 9.13796 4.43111 8.656 4.7616L4.4 7.68Z"
                                                    stroke="url(#paint0_linear_7002_2508)"
                                                    strokeWidth="1.2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <defs>
                                                    <linearGradient
                                                        id="paint0_linear_7002_2508"
                                                        x1="10"
                                                        y1="4"
                                                        x2="10"
                                                        y2="16"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#4D9FFC" />
                                                        <stop
                                                            offset="1"
                                                            stopColor="#3B80DE"
                                                        />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                            <svg
                                                onClick={() => {
                                                    setOpenSetting(true);
                                                }}
                                                style={{
                                                    width:
                                                        loadBinary || mediumBranch?.relationship?.kind !== Relationship_Kind.PERSONAL
                                                            ? '0px'
                                                            : 'unset',
                                                }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none">
                                                <rect
                                                    className="rect"
                                                    width="20"
                                                    height="20"
                                                    rx="4"
                                                    fill="#333650"
                                                />
                                                <path
                                                    d="M10 12.1C11.1598 12.1 12.1 11.1598 12.1 10C12.1 8.8402 11.1598 7.9 10 7.9C8.8402 7.9 7.9 8.8402 7.9 10C7.9 11.1598 8.8402 12.1 10 12.1Z"
                                                    stroke="url(#paint0_linear_7002_2510)"
                                                    strokeWidth="1.2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M14.7091 11.9091C14.6244 12.101 14.5991 12.3139 14.6365 12.5204C14.674 12.7268 14.7724 12.9173 14.9191 13.0673L14.9573 13.1055C15.0756 13.2237 15.1695 13.364 15.2335 13.5185C15.2976 13.673 15.3305 13.8387 15.3305 14.0059C15.3305 14.1732 15.2976 14.3388 15.2335 14.4933C15.1695 14.6478 15.0756 14.7882 14.9573 14.9064C14.8391 15.0247 14.6987 15.1186 14.5442 15.1826C14.3897 15.2467 14.2241 15.2796 14.0568 15.2796C13.8896 15.2796 13.7239 15.2467 13.5694 15.1826C13.4149 15.1186 13.2746 15.0247 13.1564 14.9064L13.1182 14.8682C12.9682 14.7215 12.7777 14.6231 12.5713 14.5856C12.3649 14.5482 12.1519 14.5735 11.96 14.6582C11.7718 14.7388 11.6113 14.8728 11.4982 15.0435C11.3851 15.2143 11.3245 15.4143 11.3236 15.6191V15.7273C11.3236 16.0648 11.1895 16.3885 10.9509 16.6272C10.7122 16.8659 10.3885 17 10.0509 17C9.71336 17 9.38964 16.8659 9.15096 16.6272C8.91227 16.3885 8.77818 16.0648 8.77818 15.7273V15.67C8.77325 15.4594 8.70508 15.2551 8.58251 15.0837C8.45994 14.9123 8.28865 14.7818 8.09091 14.7091C7.89897 14.6244 7.68606 14.5991 7.47963 14.6365C7.27319 14.674 7.0827 14.7724 6.93273 14.9191L6.89455 14.9573C6.77634 15.0756 6.63598 15.1695 6.48147 15.2335C6.32696 15.2976 6.16135 15.3305 5.99409 15.3305C5.82683 15.3305 5.66122 15.2976 5.50671 15.2335C5.35221 15.1695 5.21184 15.0756 5.09364 14.9573C4.9753 14.8391 4.88143 14.6987 4.81738 14.5442C4.75333 14.3897 4.72036 14.2241 4.72036 14.0568C4.72036 13.8896 4.75333 13.7239 4.81738 13.5694C4.88143 13.4149 4.9753 13.2746 5.09364 13.1564L5.13182 13.1182C5.27852 12.9682 5.37694 12.7777 5.41437 12.5713C5.4518 12.3649 5.42653 12.1519 5.34182 11.96C5.26115 11.7718 5.12721 11.6113 4.95648 11.4982C4.78575 11.3851 4.58568 11.3245 4.38091 11.3236H4.27273C3.93518 11.3236 3.61146 11.1895 3.37277 10.9509C3.13409 10.7122 3 10.3885 3 10.0509C3 9.71336 3.13409 9.38964 3.37277 9.15096C3.61146 8.91227 3.93518 8.77818 4.27273 8.77818H4.33C4.54063 8.77325 4.74491 8.70508 4.91628 8.58251C5.08765 8.45994 5.21818 8.28865 5.29091 8.09091C5.37562 7.89897 5.40089 7.68606 5.36346 7.47963C5.32603 7.27319 5.22761 7.0827 5.08091 6.93273L5.04273 6.89455C4.92439 6.77634 4.83052 6.63598 4.76647 6.48147C4.70242 6.32696 4.66945 6.16135 4.66945 5.99409C4.66945 5.82683 4.70242 5.66122 4.76647 5.50671C4.83052 5.35221 4.92439 5.21184 5.04273 5.09364C5.16093 4.9753 5.3013 4.88143 5.4558 4.81738C5.61031 4.75333 5.77593 4.72036 5.94318 4.72036C6.11044 4.72036 6.27605 4.75333 6.43056 4.81738C6.58507 4.88143 6.72543 4.9753 6.84364 5.09364L6.88182 5.13182C7.0318 5.27852 7.22228 5.37694 7.42872 5.41437C7.63515 5.4518 7.84806 5.42653 8.04 5.34182H8.09091C8.27913 5.26115 8.43965 5.12721 8.55271 4.95648C8.66578 4.78575 8.72646 4.58568 8.72727 4.38091V4.27273C8.72727 3.93518 8.86136 3.61146 9.10005 3.37277C9.33873 3.13409 9.66245 3 10 3C10.3375 3 10.6613 3.13409 10.9 3.37277C11.1386 3.61146 11.2727 3.93518 11.2727 4.27273V4.33C11.2735 4.53477 11.3342 4.73484 11.4473 4.90557C11.5604 5.0763 11.7209 5.21024 11.9091 5.29091C12.101 5.37562 12.3139 5.40089 12.5204 5.36346C12.7268 5.32603 12.9173 5.22761 13.0673 5.08091L13.1055 5.04273C13.2237 4.92439 13.364 4.83052 13.5185 4.76647C13.673 4.70242 13.8387 4.66945 14.0059 4.66945C14.1732 4.66945 14.3388 4.70242 14.4933 4.76647C14.6478 4.83052 14.7882 4.92439 14.9064 5.04273C15.0247 5.16093 15.1186 5.3013 15.1826 5.4558C15.2467 5.61031 15.2796 5.77593 15.2796 5.94318C15.2796 6.11044 15.2467 6.27605 15.1826 6.43056C15.1186 6.58507 15.0247 6.72543 14.9064 6.84364L14.8682 6.88182C14.7215 7.0318 14.6231 7.22228 14.5856 7.42872C14.5482 7.63515 14.5735 7.84806 14.6582 8.04V8.09091C14.7388 8.27913 14.8728 8.43965 15.0435 8.55271C15.2143 8.66578 15.4143 8.72646 15.6191 8.72727H15.7273C16.0648 8.72727 16.3885 8.86136 16.6272 9.10005C16.8659 9.33873 17 9.66245 17 10C17 10.3375 16.8659 10.6613 16.6272 10.9C16.3885 11.1386 16.0648 11.2727 15.7273 11.2727H15.67C15.4652 11.2735 15.2652 11.3342 15.0944 11.4473C14.9237 11.5604 14.7898 11.7209 14.7091 11.9091Z"
                                                    stroke="url(#paint1_linear_7002_2510)"
                                                    strokeWidth="1.2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <defs>
                                                    <linearGradient
                                                        id="paint0_linear_7002_2510"
                                                        x1="10"
                                                        y1="3"
                                                        x2="10"
                                                        y2="17"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#4D9FFC" />
                                                        <stop
                                                            offset="1"
                                                            stopColor="#3B80DE"
                                                        />
                                                    </linearGradient>
                                                    <linearGradient
                                                        id="paint1_linear_7002_2510"
                                                        x1="10"
                                                        y1="3"
                                                        x2="10"
                                                        y2="17"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop stopColor="#4D9FFC" />
                                                        <stop
                                                            offset="1"
                                                            stopColor="#3B80DE"
                                                        />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                        </div>
                                        <div className="content">
                                            <TeamBinarItem
                                                partner={leftBranch}
                                                setLoadBinary={setLoadBinary}
                                                setPositionBinary={setPositionBinary}
                                                teamQuantity={mediumBranch?.branchLeft?.teamQuantity}
                                                arrow={
                                                    mediumBranch?.branchSelectStrategy === 1
                                                        ? true
                                                        : mediumBranch?.branchSelectStrategy === 3 &&
                                                          getBranch(mediumBranch.branchLeft, mediumBranch.branchRight) === 1
                                                        ? true
                                                        : false
                                                }
                                            />
                                            <svg
                                                style={{ marginRight: '-20px' }}
                                                className="arrow"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="31"
                                                height="10"
                                                viewBox="0 0 31 10"
                                                fill="none">
                                                <path
                                                    d="M0.575735 4.57574C0.341419 4.81005 0.341419 5.18995 0.575735 5.42426L4.39411 9.24264C4.62843 9.47696 5.00833 9.47696 5.24264 9.24264C5.47695 9.00833 5.47695 8.62843 5.24264 8.39411L1.84853 5L5.24264 1.60589C5.47695 1.37157 5.47695 0.991674 5.24264 0.757359C5.00833 0.523045 4.62843 0.523045 4.39411 0.757359L0.575735 4.57574ZM31 4.4H29.75V5.6H31V4.4ZM27.25 4.4L24.75 4.4V5.6L27.25 5.6V4.4ZM22.25 4.4L19.75 4.4V5.6L22.25 5.6V4.4ZM17.25 4.4H14.75V5.6H17.25V4.4ZM12.25 4.4H9.75V5.6H12.25V4.4ZM7.25 4.4L4.75 4.4V5.6L7.25 5.6V4.4ZM2.25 4.4H0.999998V5.6H2.25V4.4Z"
                                                    fill="url(#paint0_linear_7009_2461)"
                                                />
                                                <defs>
                                                    <linearGradient
                                                        id="paint0_linear_7009_2461"
                                                        x1="39.5976"
                                                        y1="4.58724"
                                                        x2="4.78065"
                                                        y2="-6.88579"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            offset="0.21"
                                                            stopColor="#666666"
                                                            stopOpacity="0"
                                                        />
                                                        <stop
                                                            offset="0.76"
                                                            stopColor="#2D88F8"
                                                        />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                            <div className="content__center">
                                                {positionBinaryList.length > 0 && (
                                                    <div
                                                        className="up"
                                                        onClick={() => {
                                                            setUp(true);
                                                            setPositionBinary(positionBinaryList[positionBinaryList.length - 1]);
                                                            setPositionBinaryList((prev) => [...prev.slice(0, -1)]);
                                                        }}>
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="10"
                                                            height="6"
                                                            viewBox="0 0 10 6"
                                                            fill="none">
                                                            <path
                                                                d="M9 4.75L5.25 1L1.5 4.75"
                                                                stroke="#A2D8FF"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                        <p>{t('up')}</p>
                                                    </div>
                                                )}
                                                <Ava
                                                    click={() => {
                                                        mediumBranch?.accountId && getAccount(mediumBranch?.accountId);
                                                    }}
                                                    width="80px"
                                                    collectionId={mediumBranch?.profile?.ava?.collectionId}
                                                    entityId={mediumBranch?.profile?.ava?.entityId}
                                                    borderColor="#4d9ffc"
                                                />
                                                <h1 className="name">
                                                    {mediumBranch?.channels &&
                                                        getLoginOrId({
                                                            channels: mediumBranch?.channels,
                                                            marketingStartedAt: mediumBranch.marketingStartedAt,
                                                            referralBranch: mediumBranch.referralBranch,
                                                            referral: mediumBranch.referral,
                                                            registrationAt: mediumBranch.registrationAt,
                                                            treeIdsBitMask: mediumBranch.treeIdsBitMask,
                                                            account: mediumBranch.account,
                                                            profile: mediumBranch.profile,
                                                            relationship: mediumBranch.relationship,
                                                            statistics: mediumBranch.statistics,
                                                        })}
                                                </h1>
                                                <div className="amount">
                                                    <h2>
                                                        {mediumBranch?.branchRight?.balanceValue &&
                                                        mediumBranch?.branchLeft?.balanceValue &&
                                                        mediumBranch?.branchLeft?.balanceValue > mediumBranch?.branchRight?.balanceValue
                                                            ? (Number(mediumBranch?.branchLeft?.balanceValue) * del).toLocaleString()
                                                            : (Number(mediumBranch?.branchRight?.balanceValue) * del).toLocaleString()}
                                                        <span>$</span>
                                                    </h2>
                                                    <h1>{t('pere')}</h1>
                                                </div>
                                            </div>
                                            <svg
                                                className="arrow"
                                                style={{ transform: 'rotate(-180deg', marginLeft: '-20px' }}
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="31"
                                                height="10"
                                                viewBox="0 0 31 10"
                                                fill="none">
                                                <path
                                                    d="M0.575735 4.57574C0.341419 4.81005 0.341419 5.18995 0.575735 5.42426L4.39411 9.24264C4.62843 9.47696 5.00833 9.47696 5.24264 9.24264C5.47695 9.00833 5.47695 8.62843 5.24264 8.39411L1.84853 5L5.24264 1.60589C5.47695 1.37157 5.47695 0.991674 5.24264 0.757359C5.00833 0.523045 4.62843 0.523045 4.39411 0.757359L0.575735 4.57574ZM31 4.4H29.75V5.6H31V4.4ZM27.25 4.4L24.75 4.4V5.6L27.25 5.6V4.4ZM22.25 4.4L19.75 4.4V5.6L22.25 5.6V4.4ZM17.25 4.4H14.75V5.6H17.25V4.4ZM12.25 4.4H9.75V5.6H12.25V4.4ZM7.25 4.4L4.75 4.4V5.6L7.25 5.6V4.4ZM2.25 4.4H0.999998V5.6H2.25V4.4Z"
                                                    fill="url(#paint0_linear_7009_2461)"
                                                />
                                                <defs>
                                                    <linearGradient
                                                        id="paint0_linear_7009_2461"
                                                        x1="39.5976"
                                                        y1="4.58724"
                                                        x2="4.78065"
                                                        y2="-6.88579"
                                                        gradientUnits="userSpaceOnUse">
                                                        <stop
                                                            offset="0.21"
                                                            stopColor="#666666"
                                                            stopOpacity="0"
                                                        />
                                                        <stop
                                                            offset="0.76"
                                                            stopColor="#2D88F8"
                                                        />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                            <TeamBinarItem
                                                partner={rightBranch}
                                                setLoadBinary={setLoadBinary}
                                                setPositionBinary={setPositionBinary}
                                                teamQuantity={mediumBranch?.branchRight?.teamQuantity}
                                                arrow={
                                                    mediumBranch?.branchSelectStrategy === 2
                                                        ? true
                                                        : mediumBranch?.branchSelectStrategy === 3 &&
                                                          getBranch(mediumBranch.branchLeft, mediumBranch.branchRight) === 2
                                                        ? true
                                                        : false
                                                }
                                            />
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </>
                </div>
            )}
            {userInfoOpen && shortInfo && (
                <Modal
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                    }}>
                    <UserProfile {...shortInfo} />
                </Modal>
            )}
            {userInfoOpenB && shortInfoB && (
                <Modal
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                        setShortInfoB(null);
                    }}>
                    <UserProfile {...shortInfoB} />
                </Modal>
            )}
            {userInfoOpen && info && (
                <Modal
                    title={t('modals.profile.header.title')}
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                    }}>
                    <ShortProfile
                        {...info}
                        view={true}
                    />
                </Modal>
            )}
            {userInfoOpenB && infoB && (
                <Modal
                    title={t('modals.profile.header.title')}
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                        setInfoB(null);
                    }}>
                    <ShortProfile
                        {...infoB}
                        view={true}
                    />
                </Modal>
            )}
            {binar && (
                <Modal
                    closeBtn={() => {
                        setQuantity(1);
                        setBinar(false);
                    }}>
                    <div
                        className="show binar"
                        style={{ marginTop: tab === 1 ? '52px' : '0px' }}>
                        <h1>{t('binar_book_title')}</h1>
                        {tab === 1 && <p dangerouslySetInnerHTML={{ __html: t('bin.p1') }}></p>}
                        <div className="binar__select">
                            <p>{t('select_binar_book_title')}</p>
                            <div className="btns">
                                <button
                                    className={quantity === 1 ? 'active' : ''}
                                    onClick={() => setQuantity(1)}>
                                    x1
                                </button>
                                <button
                                    className={quantity === 3 ? 'active' : ''}
                                    onClick={() => setQuantity(3)}>
                                    x3
                                </button>
                                <button
                                    className={quantity === 7 ? 'active' : ''}
                                    onClick={() => setQuantity(7)}>
                                    x7
                                </button>
                            </div>
                        </div>

                        <div className="binar__check">
                            {tab === 1 && (
                                <h2>
                                    {t('binar_check_1', { area: 'P1' })}
                                    <span>{valueBinar.toLocaleString()}$</span>
                                </h2>
                            )}
                            <h2>
                                {tab === 1 ? t('binar_check_2', { x: `x${quantity}` }) : t('binar_check_3', { x: `x${quantity}` })}
                                <span>{(quantity * (tab === 1 ? 25 : 800)).toLocaleString()}$</span>
                            </h2>
                            {tab === 1 && <div className="line"></div>}
                            {tab === 1 && (
                                <h2>
                                    {t('binar_book_result')} <span>{(valueBinar + quantity * (tab === 1 ? 25 : 800)).toLocaleString()}$</span>
                                </h2>
                            )}
                        </div>
                        <div className="btns down">
                            <Button
                                title={t('btns.cancel')}
                                onClick={() => {
                                    setQuantity(1);
                                    setBinar(false);
                                }}
                            />
                            <Button
                                title={t('matrix.reserv.btn')}
                                onClick={() => {
                                    setValue(valueBinar + quantity * 25);
                                    binarFetch(quantity, tab);
                                }}
                            />
                        </div>
                    </div>
                </Modal>
            )}
            {openSetting && (
                <Modal closeBtn={() => setOpenSetting(false)}>
                    <div className="show2 show">
                        <h1>{t('setting.binary')}</h1>
                        <SettingBinary
                            openSetting={setFetchBinary}
                            positionId={mediumBranch?.positionId || 1}
                            branchSelectStrategy={mediumBranch?.branchSelectStrategy || 1}
                        />
                        <div className="btns">
                            {tab === 1 && treeAccounts[15].activatedQuantity + treeAccounts[15].bookingQuantity < 7 && <p>{t('dop')}</p>}
                            {tab === 2 && treeAccounts[16].activatedQuantity + treeAccounts[16].bookingQuantity < 7 && <p>{t('dop')}</p>}

                            {(tab === 1 ? getInfoForBinarS(treeAccounts[15]) : getInfoForBinarS(treeAccounts[16])) === placesBinar.THREE && (
                                <>
                                    <Button
                                        title={t('bin.btn_three', {
                                            amount: getAmountForBinar(tab) * 2,
                                        })}
                                        onClick={() => {
                                            setQuantity(2);
                                            binarFetch(2, tab);
                                        }}
                                    />
                                    <Button
                                        title={t('bin.btn_seven', {
                                            amount: getAmountForBinar(tab) * 6,
                                        })}
                                        onClick={() => {
                                            setQuantity(6);
                                            binarFetch(6, tab);
                                        }}
                                    />
                                </>
                            )}
                            {(tab === 1 ? getInfoForBinarS(treeAccounts[15]) : getInfoForBinarS(treeAccounts[16])) === placesBinar.SEVEN && (
                                <>
                                    <Button
                                        title={t('bin.btn_seven', {
                                            amount: getAmountForBinar(tab) * 4,
                                        })}
                                        onClick={() => {
                                            setQuantity(4);
                                            binarFetch(4, tab);
                                        }}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </Modal>
            )}{' '}
            {isOpen && (
                <Modal closeBtn={() => setIsOpen(false)}>
                    <div className="show">
                        <h1>{t('matrix.reserv.modals.not_money.title')}</h1>
                        <p>{t('matrix.reserv.modals.not_money.text', { amount: value.toLocaleString() })}</p>
                        <Button
                            width="180px"
                            style={{ marginTop: '32px' }}
                            title={t('matrix.reserv.modals.not_money.btn')}
                            onClick={() => navigate('/wallet?deposit=true')}
                        />
                    </div>
                </Modal>
            )}
            {isReady && (
                <Modal closeBtn={() => setIsReady(false)}>
                    <div className="show">
                        <h1>{t('matrix.reserv.modals.ready.title')}</h1>
                        <p>{t('matrix.reserv.modals.ready.text', { amount: value.toLocaleString(), positions })}</p>
                        <Button
                            style={{ marginTop: '32px' }}
                            width="180px"
                            title={t('matrix.reserv.modals.ready.btn')}
                            onClick={() => binarFetch(quantity, tab)}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default Areas;
